import "./style.scss";
import * as React from "react";
import { EmailSelect } from "../../../../common";
import { Popover, Icon } from "antd";

import Section from "../../../../core/Section";
import EmailPopover from "./EmailPopover";

class ReportContact extends React.Component<any, any> {
  render() {
    const { contacts, editContacts, form } = this.props;
    return (
      <Section className="report-contact" title="Delivery Notification Contact">
        <EmailSelect
          value={contacts}
          handleChange={(e: any) => editContacts(e.target.value)}
          disabled={false}
          tokenSeparators={[" ", ","]}
          placeholder="To :"
          form={form}
          name="notification_email"
          form_value_key="notification_email"
          popover={EmailPopover}
          label="Email Address(s)"
        />
      </Section>
    );
  }
}

export default ReportContact;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportContact/component.tsx